package com.imobly.imobly.ui.screens.home

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ExitToApp
import androidx.compose.material.icons.filled.CalendarToday
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.Menu
import androidx.compose.material.icons.filled.QueryStats
import androidx.compose.material.icons.outlined.Category
import androidx.compose.material.icons.outlined.Feedback
import androidx.compose.material.icons.outlined.ManageAccounts
import androidx.compose.material.icons.outlined.OtherHouses
import androidx.compose.material.icons.outlined.PeopleOutline
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.navigation.compose.rememberNavController
import com.imobly.imobly.ui.components.confirmdialog.ConfirmDialogComp
import com.imobly.imobly.ui.components.title.TitleComp
import com.imobly.imobly.ui.theme.colors.BackGroundColor
import com.imobly.imobly.ui.theme.colors.PrimaryColor
import com.imobly.imobly.ui.theme.colors.TitleColor
import com.imobly.imobly.ui.theme.fonts.montserratFont
import com.imobly.imobly.viewmodel.HomeViewModel
import imobly.composeapp.generated.resources.Res
import imobly.composeapp.generated.resources.image_logo_complete
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview

@Composable
fun HomeScreen(homeViewModel: HomeViewModel) {
    val drawerState = rememberDrawerState(DrawerValue.Closed)
    val scope = rememberCoroutineScope()
    val scrollState = rememberScrollState()

    ModalNavigationDrawer(
        drawerState = drawerState,
        drawerContent = {
            ModalDrawerSheet(
                modifier = Modifier.width(280.dp),
                drawerContainerColor = BackGroundColor
            ) {
                Spacer(Modifier.height(24.dp))
                Box(
                    modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                    contentAlignment = Alignment.Center
                ) {
                    Image(
                        painter = painterResource(Res.drawable.image_logo_complete),
                        contentDescription = "Logo",
                        modifier = Modifier.size(120.dp)
                    )
                }
                Spacer(Modifier.height(24.dp))
                HorizontalDivider(color = Color.LightGray)
                Spacer(Modifier.height(16.dp))

                NavigationDrawerItem(
                    label = {
                        Text(
                            "Ver perfil",
                            fontFamily = montserratFont(),
                            fontWeight = FontWeight.Bold,
                            fontSize = 14.sp
                        )
                    },
                    icon = { Icon(Icons.Outlined.ManageAccounts, contentDescription = "Perfil") },
                    selected = false,
                    onClick = {
                        scope.launch { drawerState.close() }
                        homeViewModel.goToEditLandLord()
                    },
                    modifier = Modifier.padding(NavigationDrawerItemDefaults.ItemPadding)
                )

                NavigationDrawerItem(
                    label = {
                        Text(
                            "Trocar o E-mail",
                            fontFamily = montserratFont(),
                            fontWeight = FontWeight.Bold,
                            fontSize = 14.sp
                        )
                    },
                    icon = { Icon(Icons.Default.Email, contentDescription = "Email") },
                    selected = false,
                    onClick = {
                        scope.launch { drawerState.close() }
                        homeViewModel.goToSendEmail()
                    },
                    modifier = Modifier.padding(NavigationDrawerItemDefaults.ItemPadding)
                )

                NavigationDrawerItem(
                    label = {
                        Text(
                            "Deslogar",
                            fontFamily = montserratFont(),
                            fontWeight = FontWeight.Bold,
                            fontSize = 14.sp,
                            color = Color.Red
                        )
                    },
                    icon = { Icon(Icons.AutoMirrored.Filled.ExitToApp, contentDescription = "Deslogar", tint = Color.Red) },
                    selected = false,
                    onClick = {
                        scope.launch { drawerState.close() }
                        homeViewModel.changeShowLogoutDialog()
                    },
                    modifier = Modifier.padding(NavigationDrawerItemDefaults.ItemPadding)
                )
            }
        }
    ) {
        Scaffold(
            topBar = {
                TopBarHomeComp(
                    onMenuClick = {
                        scope.launch { drawerState.open() }
                    }
                )
            },
            snackbarHost = { SnackbarHost(homeViewModel.snackMessage.value) }
        ) { paddingValues ->
            Column(
                modifier = Modifier
                    .background(BackGroundColor)
                    .padding(paddingValues)
                    .fillMaxSize()
                    .verticalScroll(scrollState),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                Spacer(Modifier.height(16.dp))
                TitleComp("Painel Administrativo", fontSize = 28.sp, backButton = false, buttonBackAction = {})

                Spacer(Modifier.height(20.dp))

                val highlightColor = PrimaryColor
                val backgroundColor = BackGroundColor

                Box(
                    modifier = Modifier
                        .widthIn(max = 1000.dp)
                        .fillMaxWidth(0.92f),
                    contentAlignment = Alignment.Center
                ) {
                    LazyVerticalGrid(
                        columns = GridCells.Adaptive(minSize = 260.dp),
                        modifier = Modifier
                            .fillMaxWidth()
                            .heightIn(max = 800.dp),
                        contentPadding = PaddingValues(8.dp),
                        horizontalArrangement = Arrangement.spacedBy(12.dp),
                        verticalArrangement = Arrangement.spacedBy(12.dp),
                        userScrollEnabled = false
                    ) {
                        item {
                            CardButtonComp(
                                text = "Gráficos",
                                icon = {
                                    Icon(
                                        Icons.Filled.QueryStats,
                                        contentDescription = "Gráfico",
                                        modifier = Modifier.fillMaxSize().padding(20.dp),
                                        tint = backgroundColor,
                                    )
                                },
                                action = { homeViewModel.goToGraphic() },
                                backgroundColor = backgroundColor,
                                highlightColor = highlightColor
                            )
                        }
                        item {
                            CardButtonComp(
                                text = "Gerenciar propriedades",
                                icon = {
                                    Icon(
                                        Icons.Outlined.OtherHouses,
                                        contentDescription = "propriedades",
                                        modifier = Modifier.fillMaxSize().padding(20.dp),
                                        tint = backgroundColor,
                                    )
                                },
                                action = { homeViewModel.goToShowProperties() },
                                backgroundColor = backgroundColor,
                                highlightColor = highlightColor
                            )
                        }

                        item {
                            CardButtonComp(
                                text = "Gerenciar locatários",
                                icon = {
                                    Icon(
                                        Icons.Outlined.PeopleOutline,
                                        contentDescription = "locatarios",
                                        modifier = Modifier.fillMaxSize().padding(20.dp),
                                        tint = backgroundColor,
                                    )
                                },
                                action = { homeViewModel.goToShowTenants() },
                                backgroundColor = backgroundColor,
                                highlightColor = highlightColor
                            )
                        }

                        item {
                            CardButtonComp(
                                text = "Gerenciar reportações",
                                icon = {
                                    Icon(
                                        Icons.Outlined.Feedback,
                                        contentDescription = "relatos",
                                        modifier = Modifier.fillMaxSize().padding(20.dp),
                                        tint = backgroundColor,
                                    )
                                },
                                action = { homeViewModel.goToShowReports() },
                                backgroundColor = backgroundColor,
                                highlightColor = highlightColor
                            )
                        }

                        item {
                            CardButtonComp(
                                text = "Gerenciar categoria",
                                icon = {
                                    Icon(
                                        Icons.Outlined.Category,
                                        contentDescription = "categoria",
                                        modifier = Modifier.fillMaxSize().padding(20.dp),
                                        tint = backgroundColor,
                                    )
                                },
                                action = { homeViewModel.goToShowCategories() },
                                backgroundColor = backgroundColor,
                                highlightColor = highlightColor
                            )
                        }

                        item {
                            CardButtonComp(
                                text = "Gerenciar contratos",
                                icon = {
                                    Icon(
                                        Icons.Outlined.ManageAccounts,
                                        contentDescription = "contratos",
                                        modifier = Modifier.fillMaxSize().padding(20.dp),
                                        tint = backgroundColor,
                                    )
                                },
                                action = { homeViewModel.goToShowLeases() },
                                backgroundColor = backgroundColor,
                                highlightColor = highlightColor
                            )
                        }

                        item {
                            CardButtonComp(
                                text = "Ver agendamentos",
                                icon = {
                                    Icon(
                                        Icons.Default.CalendarToday,
                                        contentDescription = "Agendamentos",
                                        modifier = Modifier
                                            .fillMaxSize()
                                            .padding(20.dp),
                                        tint = backgroundColor,
                                    )
                                },
                                action = { homeViewModel.goToShowAppointment() },
                                backgroundColor = backgroundColor,
                                highlightColor = highlightColor
                            )
                        }
                    }
                }
                Spacer(Modifier.height(40.dp))
            }
        }
    }

    ConfirmDialogComp(
        showDialog = homeViewModel.showLogoutDialogState.value,
        title = "Confirmar saída",
        message = "Tem certeza que deseja deslogar do sistema?",
        onConfirm = {
            homeViewModel.changeShowLogoutDialog()
            homeViewModel.logOut()
        },
        onDismiss = {
            homeViewModel.changeShowLogoutDialog()
        }
    )
}

@Composable
fun TopBarHomeComp(onMenuClick: () -> Unit) {
    Box(
        Modifier
            .fillMaxWidth()
            .background(BackGroundColor)
            .padding(8.dp)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            IconButton(onClick = onMenuClick) {
                Icon(
                    imageVector = Icons.Default.Menu,
                    contentDescription = "Menu",
                    tint = TitleColor
                )
            }

            Box(
                modifier = Modifier
                    .weight(1f)
                    .padding(end = 48.dp),
                contentAlignment = Alignment.Center
            ) {
                Image(
                    painter = painterResource(Res.drawable.image_logo_complete),
                    contentDescription = "Logo",
                    modifier = Modifier.size(120.dp)
                )
            }
        }
    }
}

@Composable
fun CardButtonComp(
    text: String,
    width: Dp = 200.dp,
    icon: @Composable () -> Unit,
    backgroundColor: Color = BackGroundColor,
    highlightColor: Color = PrimaryColor,
    action: () -> Unit
) {
    OutlinedCard(
        modifier = Modifier
            .fillMaxWidth()
            .height(100.dp),
        onClick = action,
    ) {
        Row {
            Column(
                Modifier.background(highlightColor)
                    .weight(1f)
                    .fillMaxHeight(),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                icon()
            }

            Column(
                Modifier.background(backgroundColor)
                    .weight(1f)
                    .fillMaxHeight(),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    text = text,
                    textAlign = TextAlign.Center,
                    fontFamily = montserratFont(),
                    fontWeight = FontWeight.Bold,
                    fontSize = 12.sp,
                    color = TitleColor
                )
            }
        }
    }
}

@Composable
@Preview
fun HomeScreenPreview() {
    val navController = rememberNavController()
    HomeScreen(HomeViewModel(navController))
}
